
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "Slideshow",
  props: {
    images: {
      type: Array as PropType<string[]>,
      required: true,
    },
  },
  data() {
    return {
      current: 0,
      selectedImage: null as string | null,
    };
  },
  computed: {
    imageCount(): number {
      return this.images.length;
    },
  },
  methods: {
    prev() {
      this.current =
        (this.current - 1 + this.images.length) % this.images.length;
    },
    next() {
      this.current = (this.current + 1) % this.images.length;
    },
    goTo(i: number) {
      this.current = i;
    },
  },
});
